import { Spin, Modal } from 'antd';
import React, { useState, useEffect, useRef } from 'react';
import SubunitForm from './SubunitForm';
import {
  addSubunit,
  addAsset,
  DEFAULT_EXERCISE_PARAMS,
  exerciseIconMap
} from '../../services/subunitService';

function SubunitAdd(props) {
  const initialValues = {
    code: '',
    description: '',
    title: ''
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  const [assetToBeAdded, setAssetToBeAdded] = useState({});
  const [payloadForm, setPayloadForm] = useState({});

  function useDidUpdateEffect(fn, inputs) {
    const didMountRef = useRef(false);

    useEffect(() => {
      if (didMountRef.current) return fn();
      else didMountRef.current = true;
    }, inputs);
  }

  useDidUpdateEffect(() => {
    const payloadToSubunitBE = { ...assetToBeAdded, ...payloadForm };
    addSubunit(payloadToSubunitBE)
      .then((response) => {
        setStatus({
          type: 'SUCCESS',
          message: 'Data added successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data to backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }, [assetToBeAdded]);

  const onSubmit = async (values) => {
    let payload = {
      ...values
    };
    if (payload.subunitType === 'Exercise' && !payload.icon) {
      payload.icon = exerciseIconMap[payload.category];
    }
    if (payload.subunitType === 'Certificate') {
      payload.icon = payload.imgData?.mobileImgData?.src;
    }
    setPayloadForm(payload);
    setStatus({ type: 'LOADING', message: 'Request in Progress!' });
    await addAsset(payload, payload.subunitType)
      .then((response) => {
        setAssetToBeAdded(response);
        setStatus({
          type: 'SUCCESS',
          message: 'Data added successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data to backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  return (
    <Modal
      title={`Add Subunit`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <SubunitForm
          type="Add"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
          visible={props.isOpen}
          setStatus={setStatus}
        />
      )}
    </Modal>
  );
}

export default SubunitAdd;
